export default consentAAM => ({ consentAAM: consentAAM ? '1' : '0' });
